// Pathify
import { make } from 'vuex-pathify'

import revision from '../../revision.js'
import auth from '../../services/auth.js'

console.log(`REVISION: ${JSON.stringify(revision)}`)

// Data
const state = {
  drawer: null,
  drawerImage: true,
  mini: false,
  version: revision.version,
  revision: revision,
  items: [
    {
      title: 'Domus',
      icon: 'mdi-view-dashboard',
      to: '/',
    },
    {
      title: 'Mon Profil',
      icon: 'mdi-account',
      to: '/participant/profile/',
    },
    {
      title: 'Mes Classes',
      icon: 'mdi-school',
      to: '/participant/classes/',
    },
    {
      title: 'Singulis',
      icon: 'mdi-email-multiple-outline',
      to: '/singulis/',
    },
    {
      title: 'Admin',
      icon: 'mdi-console',
      items: [
        {
          title: 'Participants',
          icon: 'mdi-account-multiple',
          to: '/admin/participants',
        },
      ],
    },
    // {
    //   title: 'Typography',
    //   icon: 'mdi-format-font',
    //   to: '/components/typography/',
    // },
    // {
    //   title: 'Icons',
    //   icon: 'mdi-chart-bubble',
    //   to: '/components/icons/',
    // },
    // {
    //   title: 'Google Maps',
    //   icon: 'mdi-map-marker',
    //   to: '/maps/google/',
    // },
    // {
    //   title: 'Notifications',
    //   icon: 'mdi-bell',
    //   to: '/components/notifications/',
    // },
  ],
}

const mutations = make.mutations(state)

const actions = {
  ...make.actions(state),
  init: async ({ dispatch }) => {
    //
  },
}

const getters = {
  userItems: state => {
    const items = []
    if (auth.isParticipant) {
      items.push({
        title: 'Domus',
        icon: 'mdi-view-dashboard',
        to: '/',
      })
      // items.push({
      //   title: 'Mon Profil',
      //   icon: 'mdi-account',
      //   to: '/participant/profile/',
      // })
      items.push({
        title: 'Mes Classes',
        icon: 'mdi-school',
        to: '/participant/classes/',

      })
      items.push({
        title: 'Mes Travaux',
        icon: 'mdi-cloud-upload',
        to: '/participant/travaux/',

      })

      const documentsItems = []

      if (auth.doSingulis()) {
        documentsItems.push({
          title: 'Singulis',
          icon: 'mdi-fountain-pen-tip',
          to: '/documents/singulis/',
        })
      }

      if (auth.doOmnibus()) {
        documentsItems.push({
          title: 'Omnibus',
          icon: 'mdi-movie-open',
          to: '/documents/omnibus/',
        })
      }

      items.push({
        title: 'Documents',
        icon: 'mdi-file-document-multiple',
        items: documentsItems,
      })
    }

    if (auth.isAdmin) {
      items.push({
        title: 'Admin',
        icon: 'mdi-console',
        items: [
          {
            title: 'Inscriptions',
            icon: 'mdi-account-multiple',
            to: '/admin/inscriptions',
          },
        ],
      })
    }

    return items
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
